/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Actions/Choose/ChooseImageAction/Content/Content/Images/Error"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Something went wrong when loading patient images"
/>
{children}
</React.Fragment>)
}